<template>
  <div style="width: 100%">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="ID" width="100">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Name" width="200">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Sync Date" width="200">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.time }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Operations" align="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleExport(scope.$index, scope.row)"
            >Export</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="Data Export"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="40%"
    >
      <span>Does it export data?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="handleConfirm()"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
	  item:{}
    };
  },
  created() {
    this.fetchTableData();
  },
  methods: {
    fetchTableData() {
      this.$api.rootV1.post(
        "/data-export/list",
        [],
        (result) => {
          this.tableData = result.data || [];
        },
        (err) => {
          console.error(err);
        }
      );
    },

    handleExport(_, row) {
      this.item = row;
      this.dialogVisible = true;
    },

    handleConfirm() {
      this.fetchData(this.item.path);
    },

    fetchData(path) {
      const loadInstance = this.$util.loading("export...");
      this.$api.rootV1.post(
        path,
        [],
        (result) => {
          this.downloadFile(result.data.url, loadInstance);
          this.dialogVisible = false;
        },
        (err) => {
          console.error(err);
          loadInstance.close();
          this.dialogVisible = false;
        }
      );
    },

    downloadFile(url, loadInstance) {
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          loadInstance.close();
          const blob = new Blob([response.data], {
            type: "application/octet-stream",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          const [first] = url.split("/").reverse();
          link.download = first;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((err) => {
          loadInstance.close();
        });
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/main/export/DataExport.vue